import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {EuiFlexGroup, EuiFilePicker, EuiSpacer, EuiFlexItem, EuiFormRow, EuiTitle, EuiPanel, EuiText, EuiSwitch } from '@elastic/eui';
import { Menu } from '../../../../components/Menus';
import { Action } from '../../../../components/Menus/interface';
import { SelectorTiposContenidoContainer as SelectorTiposContenido } from '../../../../components/Selectores/TiposContenidoPeriodoAbierto/container';
import { SumarigramaContainer } from '../../../Consultas/Sumarigrama/Screen';
import { TablaLogImportaciones } from '../../LogImportaciones/Components/tablaLog';
import { useUserSettings } from "../../../../context/CurrentUserContext";
import { SelectorTipoImportacionCG } from '../../../../components/Selectores/TipoImportacionCG/selector'

interface Props {
  handleImportar (data: any): any;
  año: any;
  reunion: any;
  dataLog: any;
  onDetalleFilter(data: any): void;
}

export const ImportarScreen = (props: Props) => {
  const { handleImportar, año, reunion, dataLog, onDetalleFilter} = props;
  const { currentUser } = useUserSettings() as any;

  let [idTipoContenido, setIdTipoContenido] = useState(undefined);  
  let [adjuntos, setAdjunto] = useState(undefined);
  let [tipoImportacion, setTipoImportacion] = useState(-1);
  let [idCentro, setIdCentro] = useState<any>(undefined);
  let [soloCentro, setSoloCentro] = useState<any>(false);

  const getData = () =>{
    return {
      adjuntos: adjuntos,
      idTipoContenido : idTipoContenido,
      tipoImportacion: (tipoImportacion == -1 ? null : tipoImportacion),
      idCentro: idCentro,
      soloCentro: soloCentro
    }
  }

  const getFilter = useMemo(()=> {return{'año':año, 'idTipoContenido':idTipoContenido}},[año,idTipoContenido])

  const onImport = () => {
    handleImportar(getData())
  }
  
  const Actions: Action[] = useMemo(()=>[
    {handle:onImport,text:"Importar",color:"danger",size:"s", isDisabled: idTipoContenido == undefined || adjuntos == undefined}
  ],[onImport, idTipoContenido, adjuntos]);

  const onChange = (value: any) => {
    setIdTipoContenido(value);
  }

  const onAddAdjunto = (value: any) => {
    setAdjunto(value);
  }

  const onChangeTipoImportacion = (value: any) => {
    setTipoImportacion(value);
  }
  
  const onClickCentro = (id:string)=> setIdCentro(id)

  return (
    <>
      <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
        {<Menu actions={Actions} className="actions"/>}
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      <EuiFlexGroup gutterSize="s" alignItems="center" className="">
        <EuiFlexItem>
          <EuiFormRow>
            <EuiTitle size="s"><h1>{(año !== undefined ? año + ' - ' + reunion : "No hay ningun periodo abierto.")}</h1></EuiTitle>
          </EuiFormRow>
          <EuiFormRow fullWidth >
            <SelectorTiposContenido valueOfSelected={idTipoContenido} onChange={(value: any) => onChange(value)} />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      {currentUser.perfil == 'CG' &&
      <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth><SelectorTipoImportacionCG value={tipoImportacion} onChange={(value: any) => onChangeTipoImportacion(value) }/></EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
       }
       <EuiSpacer size="m" />
      <EuiFlexGroup style={{height:'80%'}}>
      {currentUser.perfil != 'CG' && 
      <EuiFlexItem grow={false} style={{height:'100%', width: '30%'}}>
      <EuiFlexGroup direction='column' gutterSize='s' style={{height:'100%'}}>
        <EuiFlexItem grow={false} style={{paddingLeft: '20px'}}>
                {/* <EuiFormRow> */}
                  {/* <EuiPanel className={soloCentro ? 'panelSwitchCheck' : 'panelSwitchUnCheck'}> */}
                    <EuiSwitch label={'Solo datos del Centro'} checked={soloCentro} onChange={(e)=>setSoloCentro(!soloCentro)} />
                  {/* </EuiPanel> */}
          </EuiFlexItem>
          <EuiFlexItem style={{overflow:'hidden', paddingLeft: '20px'}} grow={false}>
          {/* <EuiFormRow style={{height:'100%'}}> */}
            <SumarigramaContainer menu={true} onlySearch={true} filter={getFilter} onClickNode={onClickCentro} style={{overflow:'auto',height: '100%', border:'none'}}/>
          {/* </EuiFormRow> */}
        </EuiFlexItem>
        
        </EuiFlexGroup>
        </EuiFlexItem>
        }
        <EuiFlexGroup direction='column' gutterSize='s' style={{height:'100%'}}>
      <EuiFlexItem>
          <EuiFormRow fullWidth>
            <EuiFilePicker
                disabled={idTipoContenido == undefined}
                fullWidth
                id="adjuntospicker"
                initialPromptText="Selecciona o arrastra el archivo a importar"
                onChange={onAddAdjunto}
              />
          </EuiFormRow>
        </EuiFlexItem>
        {dataLog.length > 0 &&
        <>
          <EuiSpacer size='m'/>
          <EuiPanel hasShadow={false}>
          <EuiText><h2>{`Log de Importación`}</h2></EuiText>
          <EuiFlexGroup>
            <EuiFlexItem style={{maxHeight:'350px', overflow:'auto'}}>
              <TablaLogImportaciones style={{overflow:'auto'}} data={dataLog} onDetalleFilter={onDetalleFilter}/>
            </EuiFlexItem>
          </EuiFlexGroup>
          </EuiPanel>
        </>
      }
        </EuiFlexGroup>
      </EuiFlexGroup>
      {/* {dataLog.length > 0 &&
        <>
          <EuiSpacer size='m'/>
          <EuiPanel hasShadow={false}>
          <EuiText><h2>{`Log de Importación`}</h2></EuiText>
          <EuiFlexGroup>
            <EuiFlexItem style={{maxHeight:'350px', overflow:'auto'}}>
              <TablaLogImportaciones style={{overflow:'auto'}} data={dataLog} onDetalleFilter={onDetalleFilter}/>
            </EuiFlexItem>
          </EuiFlexGroup>
          </EuiPanel>
        </>
      } */}
    </>
  );
};

export default ImportarScreen;
